import { Injectable } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { SearchContentComponent } from "./search-content.component";

@Injectable({
  providedIn: "root"
})
export class SearchModalService {
  private _modalRef: BsModalRef;

  resourceUrl: string;
  data: any[];

  constructor(private _modalService: BsModalService) {}

  show() {
    this._modalRef = this._modalService.show(SearchContentComponent, {
      initialState: {
        service: this
      }
    });
  }

  hide() {
    this._modalRef.hide();
  }
}
